<template>
  <div aria-live="assertive" class="tag-cloud tag-cloud--light ds-7">
    <div class="tag tag--chathams" v-for="pill in pills" :key="pill.id">
      <span>{{ pill.name }}</span>
      <span class="visuallyhidden"> {{ $t('org.filterHasBeenAdded') }}</span
      ><button
        id="removeItems"
        aria-live="off"
        :aria-label="getRemoveAriaLabel(pill)"
        class="tag__close"
      >
        <i class="fa fa-times-circle"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pills: { required: true, type: Array },
  },
  methods: {
    getRemoveAriaLabel({ ariaLabel, name }) {
      if (ariaLabel) return ariaLabel
      else if (name) return `${this.$t('common.remove')} ${name} ${this.$t('common.filter', 1)}`
      else return `${this.$t('common.remove')} ${this.$t('ui.pill')}`
    },
  },
}
</script>
